import Paper from "@material-ui/core/Paper";
import React, { useEffect, useState, useMemo } from "react";
import { fetchJSON } from "helpers/axios";
import { useLocation } from "react-router-dom";

const QrCodePayment = () => {
  const location = useLocation();
  // const url = window.location.href;
  const url = location.search;
  // let urlParams = new URLSearchParams(url);
  // const payeeId = urlParams.get("applicantId");
  const transactionId = url !== "" ? url?.match(/transactionId=(.*)/)[1] : "";

  if (transactionId == "") {
    window.location.href = "/portal";
  }

  const [paymentReceipt, setPaymentReceipt] = useState([]);

  useMemo(async () => {
    try {
      const response = await fetchJSON(
        `api/PaymentReceiptByRRR?transactionId=${transactionId}`,
        null,
        "GET"
      );
      setPaymentReceipt(response);
    } catch (error) {
      console.log(error);
    }
  }, []);

  return (
    <>
      <Paper elevation={2}>
        <div id="content">
          <div className="container border border-primary">
            <header
              className="mt-4 text-center"
              // style={{ borderBottom: "1px solid gray" }}
            >
              <div className="d-flex justify-content-between">
                <div>
                  <img
                    className="img-fluid"
                    src="https://unicrossdoc.blob.core.windows.net/passport/UNICROSS%20Logo%20-%20whitebg.png?sp=r&st=2022-10-17T15:19:36Z&se=2122-10-17T23:19:36Z&spr=https&sv=2021-06-08&sr=b&sig=TlwLNipSBRc%2BhjvTbnacUYmgEvo1H7s41Jd5tHqYMkE%3D"
                    alt=""
                    style={{ maxWidth: "150px", maxHeight: "150px" }}
                  />
                </div>
                <div>
                  {/* <h1>{paymentReceipt.passport}</h1> */}
                  <img
                    className="img-fluid"
                    src={paymentReceipt.passport}
                    alt=""
                    style={{ maxWidth: "150px", maxHeight: "150px" }}
                  />
                </div>
              </div>
            </header>

            <div className="mb-5 text-center text-center">
              <h1>
                <strong>Payment Receipt</strong>
              </h1>
            </div>

            <div className="d-flex justify-content-between">
              <div>
                <h5 style={{ fontSize: "18px" }}>Babalola Academy Collage of Health Technology, Ilorin</h5>
              </div>
              <div className="text-center">
                <strong>{paymentReceipt.name}</strong>
                <p>{paymentReceipt.matricNo}</p>
                <p>{paymentReceipt.level} LEVEL</p>
                <p>{paymentReceipt.department}</p>
              </div>
              <div className="text-right">
                <strong className="text-end">
                  SPC: SPC{paymentReceipt.payeeNo}
                </strong>
                <p>
                  <strong className="text-end">
                    RRR: {paymentReceipt.RRR}
                  </strong>
                </p>
                <p>
                  <strong className="text-end">
                    Generated On: {paymentReceipt.paymentDate}
                  </strong>
                </p>
                <p>
                  <strong>{paymentReceipt.generatedDate}</strong>
                </p>
              </div>
            </div>
            <br />
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Payment Reference:</th>
                  <th scope="col">Method</th>
                  <th scope="col">Payment For</th>
                  <th scope="col">Session</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{paymentReceipt.RRR}</td>
                  <td>UPL</td>
                  <td>{paymentReceipt.paymentName}</td>
                  <td>{paymentReceipt.session}</td>
                  <td>&#8358;{paymentReceipt.amount}</td>
                </tr>
                <tr>
                  <td colspan="2"></td>
                  <td colspan="2">
                    <strong className="text-right">
                    Interswitch/Bank Service Charge
                    </strong>
                  </td>
                  <td>&#8358;{paymentReceipt.charges}</td>
                </tr>
              </tbody>
            </table>
            <div className="text-right">
              <h4>
                <strong style={{ fontSize: "25px" }}>Amount Paid: </strong>
                <span className="text-muted" style={{ fontSize: "35px" }}>
                  &#8358;{paymentReceipt.amount}
                </span>
              </h4>
            </div>
            <br />
            <div className="d-flex justify-content-between mb-5 mt-3">
              <div>
                <h5 className="text-muted" style={{ fontSize: "20px" }}>
                  <i>
                    <strong>Verify Documente</strong>
                  </i>
                </h5>
                <div>
                  {/* <h1>{paymentReceipt.passport}</h1> */}
                  <img
                    className="img-fluid"
                    src={paymentReceipt.QRcode}
                    alt=""
                    style={{ maxWidth: "130px", maxHeight: "130px" }}
                  />
                </div>
              </div>
              <div>
                <strong>
                  <h5 className="text-muted" style={{ fontSize: "20px" }}>
                    Payment Methods:
                  </h5>
                </strong>
                <img
                  src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(17).png"
                  alt=""
                  style={{ height: "50%", width: "80%", objectFit: "" }}
                />
              </div>
              <div className="mb-5">
                <img
                  src="https://unicrossdoc.blob.core.windows.net/passport/MicrosoftTeams-image%20(16).png"
                  alt=""
                  style={{ height: "80%", width: "80%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
};

export default QrCodePayment;
